import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901MasterInputTabModel } from "../kymw6901-master-input-tab.model";


/**
 * マスタ入力表を登録するサービス
 *
 * @export RegistMasterInputService
 * @class RegistMasterInputService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistMasterInputService extends PlessJsonResponderSub<null> {
  private model: KYMW6901MasterInputTabModel;
  private successFunc = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistMasterInputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        RegistMasterInput: {
          parameter: {
            ProposalId: this.model.masterInput.proposalId,
            JanCode: this.model.masterInput.janCode,
            GoodsName: this.model.masterInput.goodsName,
            StandardName: this.model.masterInput.standardName,
            PublishMediumType: this.model.masterInput.mediumType,
            ClassCode: this.model.masterInput.classCode,
            LargeClassCode: this.model.masterInput.largeClassCode,
            MiddleClassCode: this.model.masterInput.middleClassCode,
            SmallClassCode: this.model.masterInput.smallClassCode,
            OrderUnitType: this.model.masterInput.orderUnitType,
            SetQuantity: this.model.masterInput.setQuantity,
            SuggestedPriceSellingNormal: this.model.masterInput.standardSellingPrice,
            SuggestedPriceSellingSpecial1: this.model.masterInput.special1SellingPrice,
            SuggestedPriceSellingSpecial2: this.model.masterInput.special2SellingPrice,
            SuggestedPricePurchaseNormal: this.model.masterInput.standardCostPrice,
            SuggestedPricePurchaseSpecial1: this.model.masterInput.special1CostPrice,
            SuggestedPricePurchaseSpecial2: this.model.masterInput.special2CostPrice,
            BundlePrice: this.model.masterInput.bundlePrice,
            UnitPriceDiv: this.model.masterInput.unitPriceDiv,
            UnitPriceCoefficient: this.model.masterInput.unitPriceCoefficient,
            UnitPriceUnit: this.model.masterInput.unitPriceUnit,
            EdlpDiv: this.model.masterInput.edlpDiv,
            ConsumeByDate: this.model.masterInput.expirationDate,
            ConsumeTerm: this.model.masterInput.bestBeforeDate,
            SetDiv: this.model.masterInput.setDiv,
            CaseSupplyDiv: this.model.masterInput.caseSupplyDiv,
            ArrivalAreaDiv: this.model.masterInput.arrivalAreaDiv,
            ArrivalGoodsTemp: this.model.masterInput.arrivalGoodsTemp,
            ArrivalAdminDays: this.model.masterInput.arrivalAdminDays,
            BrandType: this.model.masterInput.brandType,
            CycleTerm: this.model.masterInput.cycleTerm,
            PriceType: this.model.masterInput.priceType,
            MakerPrice: this.model.masterInput.markerPrice,
            PackagePhotographNum: this.model.masterInput.packagePhotoNum,
            PackageDataNum: this.model.masterInput.packageDataNum,
            PeakPhotographNum: this.model.masterInput.peakPhotoNum,
            PeakDataNum: this.model.masterInput.peakDataNum,
            CookingNecessaryPhotoNum: this.model.masterInput.cookingNecessaryPhotoNum,
            CookingNecessaryDataNum: this.model.masterInput.cookingNecessaryDataNum,
            CookingUnnecessaryPhotoNum: this.model.masterInput.cookingUnnecessaryPhotoNum,
            CookingUnnecessaryDataNum: this.model.masterInput.cookingUnnecessaryDataNum,
            MaterialPhotographNum: this.model.masterInput.materialPhotoNum,
            MaterialDataNum: this.model.masterInput.materialDataNum,
            BacksidePhotographNum: this.model.masterInput.backsidePhotoNum,
            BacksideDataNum: this.model.masterInput.backsideDataNum,
            GoodsExplanation: this.model.masterInput.goodsExplanation,
            Catchphrase: this.model.masterInput.catchPhrase,
            RecommendComment: this.model.masterInput.recommendComment,
            UsefulInfoEnclosure: this.model.masterInput.usefulInfoEnclosure,
            UsefulInfoConfiguration: this.model.masterInput.usefulInfoConfiguration,
            UsefulInfoOther: this.model.masterInput.usefulInfoOther,
            UsefulInfoSize: this.model.masterInput.usefulInfoSize,
            HandlingCaution: this.model.masterInput.handlingCaution,
            ConsumeTaxRate: this.model.masterInput.consumeTaxRate,
            AlcoholPercentage: this.model.masterInput.alcoholPercentage,
            FruitJuice: this.model.masterInput.fruitJuice,
            SakeMeterValue: this.model.masterInput.sakeMeterValue,
            Body: this.model.masterInput.body,
            FunctionalOrFoshu: this.model.masterInput.functionalOrFoshu,
            LiquorCode: this.model.masterInput.liquorCode,
            AlcoholType: this.model.masterInput.alcoholType,
            ContainerForm: this.model.masterInput.containerForm,
            ApplyTermStart: this.model.masterInput.applyTermStart,
            ApplyTermEnd: this.model.masterInput.applyTermEnd,
            SeasonConsumeDiv: this.model.masterInput.seasonConsumeDiv ? '1' : '0',
            SeasonConsumeTermStart: this.model.masterInput.seasonConsumeTermStart.replace(/\//g, ''),
            SeasonConsumeTermEnd: this.model.masterInput.seasonConsumeTermEnd.replace(/\//g, ''),
            StinkGoodsDiv: this.model.masterInput.stinkGoodsDiv,
            ListingGoodsName: this.model.masterInput.listingGoodsName,
            ListingType: this.model.masterInput.listingType,
            ListingContentsQuantity: this.model.masterInput.listingContentsQuantity,
            ListingSize: this.model.masterInput.listingSize,
            ListingSizeCm: this.model.masterInput.listingSizeCm,
            ListingNumber: this.model.masterInput.listingNumber,
            ListingColor: this.model.masterInput.listingColor,
            PieceSizeLength: this.model.masterInput.pieceSizeLength,
            PieceSizeWidth: this.model.masterInput.pieceSizeWidth,
            PieceSizeHeight: this.model.masterInput.pieceSizeHeight,
            PieceWeight: this.model.masterInput.pieceWeight,
            CaseSizeLength: this.model.masterInput.caseSizeLength,
            CaseSizeWidth: this.model.masterInput.caseSizeWidth,
            CaseSizeHeight: this.model.masterInput.caseSizeHeight,
            CaseWeight: this.model.masterInput.caseWeight,
            IngredientInfo: this.model.masterInput.ingredientInfo,
            IngredientsDisp: this.model.masterInput.ingredientDisp,
            RelationPcodeOld: this.model.masterInput.relationPCodeOld,
            SpecialOrderType: this.model.masterInput.specialOrderType,
            StockType: this.model.masterInput.stockType,
            PdPilingUpDays: this.model.masterInput.pdPilingUpDays,
            FactoryAddress1: this.model.masterInput.factoryAddress1,
            FactoryAddress2: this.model.masterInput.factoryAddress2,
            FcmcFee: this.model.masterInput.fcmcFee,
            PCode: this.model.masterInput.pCode,
            ItemCode: this.model.masterInput.itemCode,
          }
        },
        EcologyDivList: {
          combination: this.model.masterInput.ecologyDivList.map(ecologyDiv => ({
            parameter: {
              EcologyDiv: ecologyDiv
            }
          }))
        },
        CoopCodeList: {
          combination: this.model.expandableCoopToCoopCodeList().map(coopCode => ({
            parameter: {
              CoopCode: coopCode
            }
          }))
        },
        MarkList: {
          combination: this.model.markDivToList().map(markDiv => ({
            parameter: {
              MarkDiv: markDiv
            }
          }))
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistMasterInputService
   */
  execute(model: KYMW6901MasterInputTabModel, successFunc?: () => void): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('registMasterInput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof RegistMasterInputService
   */
  success(): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}

